"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateEmptyTournamentArray = void 0;
var generateRandomReduceWidth = function (maxWidth, iterationNumber) {
    var size = maxWidth - Math.random() * iterationNumber * 12;
    return size > 0 ? size : 0;
};
var generateOpacity = function (iterationNumber) {
    var opacity = 1 - iterationNumber / 6;
    return opacity > 0 ? opacity : 0;
};
var generateEmptyTournamentArray = function (countPlayers, maxCount, sizes) {
    var emptyPlayers = [];
    var maxWidthName = (sizes === null || sizes === void 0 ? void 0 : sizes.maxWidthName) || 110;
    var maxWidthResults = (sizes === null || sizes === void 0 ? void 0 : sizes.maxWidthResults) || 90;
    for (var i = 0; i < maxCount - countPlayers; i++) {
        emptyPlayers.push({
            number: countPlayers + i + 1,
            sizeName: generateRandomReduceWidth(maxWidthName, i),
            sizeResults: generateRandomReduceWidth(maxWidthResults, i),
            opacity: generateOpacity(i),
        });
    }
    return emptyPlayers;
};
exports.generateEmptyTournamentArray = generateEmptyTournamentArray;
